module.exports = __webpack_public_path__ + "img/behavior.89c7124c.png";